
function parseAdviceItems(data) {
 if((!data) || data.length==0){
    return null;
  }
  else {
    return JSON.stringify(data);
  }
}

function parseGetAdviceItemList(data) {
  if((!data) || data.length==0){
      return null;
  }
  else {
    return JSON.stringify(data);
  }
}


function parsePdfStatementData(data) {
  return{
    data : JSON.stringify(data.result),
  }
}

function serviceFactory({ api }) {
  const getAdviceItems = (strtdate, enddate, portfolioId, outputType, metaData) =>
    api.getAdviceItems(strtdate, enddate, portfolioId, outputType, metaData)
      .then(parseAdviceItems);

  const getAdviceItemList = (strtdate, enddate, portfolioId, outputType, metaData) =>
    api.getAdviceItemList(strtdate, enddate, portfolioId, outputType, metaData)
      .then(parseGetAdviceItemList);

  const getPdfStatement = ({accountId, docId, metaData}) =>
  api
  .getPdfStatement(accountId, docId, metaData)
  .then(parsePdfStatementData);

   return { getAdviceItems, getAdviceItemList, getPdfStatement};
}

module.exports = serviceFactory;
